import { ChoiceField } from './ChoiceField';
import type { FormFieldComponent } from './types';

/** No `formSchema`: see `ChoiceField` for why an unfillable field must not be required. */
const GenericFormInputSelect: FormFieldComponent = () => <ChoiceField family="formFields" role="selectListFormField" />;

export default GenericFormInputSelect;
